export default __webpack_public_path__ + "static/audio-cardio-6-d-8fe93dd195db913f1246231777ae95fa.webp";